import DetailBooking from "./DetailBooking";

export default DetailBooking;
